<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users"></i> Cadastro de HSM</h3>
        <small>
            Cadastro de HSM para utilização no disparo de mensagens.
        </small>
      </div>
    </div>
    <HsmAdd v-if="showAdd" ref="HsmAdd" v-on:Back="onBack" />
    <HsmGrid
      v-if="!showAdd"
      ref="ListaInteligenteGrid"
      v-on:New="onNew"
      v-on:Edit="onEdit"
    />
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import HsmGrid from '@/views/private/configurations/hsm/components/list/ListaHsm.vue'
import HsmAdd from '@/views/private/configurations/hsm/components/add/HsmAdd.vue'

export default {
  name: 'ListaHsm',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    HsmGrid,
    HsmAdd
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () { },
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.HsmAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/hsm/Hsm.vue